import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PlusIcon } from '@heroicons/react/24/outline';

import useEasypayGate from 'hooks/useEasypayGate';
import { EasypayLockedHint } from 'components/EasypayPayout';

/**
 * "Create event", in the dashboard's pill style, aware of the Easypay gate
 * (T2B-423).
 *
 * Creating is open to every promoter — without Easypay the event is saved as
 * a draft, and only publishing waits for the account. The "i" beside the
 * button says so while the promoter isn't connected.
 */
const CreateEventButton = ({ className = '' }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { blocked } = useEasypayGate();

  return (
    <span className="inline-flex items-center gap-1.5">
      <button
        type="button"
        onClick={() => navigate('/create-event')}
        className={[
          'inline-flex items-center justify-center gap-2 h-10 px-4 rounded-full text-sm font-bold shadow-softer transition-colors',
          'bg-brand hover:bg-brand-hover text-ink-strong',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <PlusIcon className="w-4 h-4" />
        {t('dashboard.create_event')}
      </button>

      {blocked && <EasypayLockedHint />}
    </span>
  );
};

export default CreateEventButton;
